// Admin wrapper for order detail - passes admin flag
import OrderDetail from "../../../order/[slug]/index";

export default function AdminOrderDetail() {
  return <OrderDetail admin />;
}
